import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';

const CreateExperimentEntryPage = lazy(
  () => import('~/features/experiments/pages/create-experiment-entry-page'),
);

/** `/experiments/create` — safety-net entry that auto-routes the user into the
 *  Google flow (info page or onboarding) without any platform selection. */
export const Route = createFileRoute('/_authenticated/_tenant/experiments_/create/')({
  component: () => (
    <div className="bg-gradient-page min-h-full">
      <Suspense fallback={<PageSkeleton />}>
        <CreateExperimentEntryPage />
      </Suspense>
    </div>
  ),
});
